import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HeaderActionEventFromHeader, MARKET_HEADER_EVENTS } from './market-header-events.model';

/**
 * Market ← Header action consumer.
 * Listens for header user actions (messages, menu, theme toggle).
 */
@Service({ autoProvided: false })
export class MarketHeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly headerAction$ = this.eventBus.on$<HeaderActionEventFromHeader>(MARKET_HEADER_EVENTS.HEADER_ACTION).pipe(
		filter(Boolean),
		distinctUntilChanged((prev, curr) => prev.id === curr.id)
	);
}
